import featureFlags from '../../common/helpers/featureFlags';
import { specialChars } from './constants';

const ValidateTag = (value) => {
  /*  eslint-disable-next-line react/destructuring-assignment */
  const trimmedValue = value.trim();
  if (trimmedValue.length === 0) {
    return 'Tag cannot be empty.';
  }
  if (trimmedValue.length > 30) {
    return 'Tag cannot be more than 30 characters long.';
  }
  if (!featureFlags.isLanguageSelectionEnabled) {
    const regex = /^[a-zA-Z0-9!"@#$%&\\'^*,<)`}|{~?(>+[\];=./:_-\s]+$/g;
    const lettersNumbersSpecialCharsOnly = trimmedValue.match(regex);
    if (!lettersNumbersSpecialCharsOnly) {
      return `Tags may only contain the following special characters ${specialChars.join(
        ' '
      )}`;
    }
  }
  return null;
};

export default ValidateTag;
